<app-input-wrapper
  [id]="id() ? id() + '-wrapper' : undefined"
  class="search-input-wrapper"
  [infoLabel]="validationMessage()"
  [invalid]="isInputInvalid()"
>
  <mat-form-field appearance="outline">
    <mat-label data-testid="search-input-label">{{ inputLabel() }}</mat-label>

    @if (mask()) {
      <input
        [attr.id]="id() ? id() + '-input' : null"
        data-testid="search-input"
        type="text"
        matInput
        appUppercase
        [placeholder]="placeholder()"
        [value]="value()"
        [mask]="mask()"
        [validation]="false"
        [disabled]="disabledSearch()"
        (input)="onInputChange($event)"
        (keydown.enter)="handleSearch()"
        (blur)="onTouched()"
      />
    } @else {
      <input
        [attr.id]="id() ? id() + '-input' : null"
        data-testid="search-input"
        matInput
        type="text"
        [appInputRegex]="allowedCharsRegex()"
        [placeholder]="placeholder()"
        [value]="value()"
        (input)="onInputChange($event)"
        [disabled]="disabledSearch()"
        (keydown.enter)="handleSearch()"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (blur)="onTouched()"
      />
    }

    <app-icon matPrefix [name]="'search'"></app-icon>

    @if (value()) {
      <button
        [attr.id]="id() ? id() + '-clear-btn' : null"
        class="cancel-search-button"
        mat-icon-button
        matSuffix
        [disabled]="disabledSearch()"
        (click)="handleClearSearch()"
        type="button"
      >
        <app-icon style="padding-left: 8px" [name]="'close'" [size]="24"></app-icon>
      </button>
    }
  </mat-form-field>
</app-input-wrapper>

<app-button
  [id]="id() ? id() + '-btn' : undefined"
  (click)="handleSearch()"
  [buttonStyle]="'danger'"
  size="large"
  [disabled]="disabledSearch() || isInputInvalid()"
>
  Buscar
</app-button>
